module.exports = __webpack_public_path__ + "static/media/btn-next-outline-wht.31ec79ef.svg";